//! moment.js locale configuration
//! locale : Valencià [val]
//! author : 

;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('moment')) :
    typeof define === 'function' && define.amd ? define(['moment'], factory) :
    factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'gen._feb._mar._abr._mai._jun._jul._ago._sep._oct._nov._dec.'.split(
                '_'
            ),
        monthsShort = 'gen_feb_mar_abr_mai_jun_jul_ago_sep_oct_nov_dec'.split('_'),
        monthsParse = [
            /^gen/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^mai/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(gener|febrer|març|abril|maig|juny|juliol|agost|septembre|octubre|novembre|decembre|gen\.?|feb\.?|mar\.?|abr\.?|mai\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dec\.?)/i;

    var val = moment.defineLocale('val', {
        months: 'gener_febrer_març_abril_maig_juny_juliol_agost_septembre_octubre_novembre_decembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(gener|febrer|març|abril|maig|juny|juliol|agost|septembre|octubre|novembre|decembre)/i,
        monthsShortStrictRegex:
            /^(gen\.?|feb\.?|mar\.?|abr\.?|mai\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dec\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijuos_divendres_dissabte'.split('_'),
        weekdaysShort: 'diu._dil._dima._dime._dij._div._dis.'.split('_'),
        weekdaysMin: 'diu_dil_dima_dime_dij_div_dis'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hui a les' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[demà a les' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a les' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ahir a les' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a les' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un día',
            dd: '%d díes',
            w: 'una setmana',
            ww: '%d setmanes',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Data inválida',
    });

    return val;

})));
